export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Most relevant',
            sort: [
                {
                    field: 'datePublished',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price descending',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price ascending',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteSize: 4,
    historySize: 5,
    currency: 'EUR'
}
